import {
  DiretoriaEstatutariaProps,
  DiretoriaEstatutariaResultProps,
  deleteDiretoriaEstatutaria,
  getAllDiretoriaEstatutaria,
  postDiretoriaEstatutaria,
  updateDiretoriaEstatutaria
} from '@app/api/naoPrevistos/diretoriaEstatutaria';
import {
  Usuario,
  UsuarioTableProps,
  getAllUsuariosMRN
} from '@app/api/usuario';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';


import { hasPermission } from '@app/helpers/permissions';
import {
  FormSubmitButton,
  GridView,
  MasterDetailForm,
  SimpleView,
  Widget,
  Button,
  Table,
  ColumnProps,
  FormatText,
  FormInput,
} from '@digital/ui';
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import ModalColaborador from './modalColaborador';
import { Steps, Col, Row, Tooltip, Modal } from 'antd';


const DiretoriaEstatutaria = () => {

  const [listResult, setListResult] = useState<DiretoriaEstatutariaResultProps[] | undefined>([])
  const [initialValue, setInitialValue] = useState<DiretoriaEstatutariaProps>({} as DiretoriaEstatutariaProps)
  const [listUsuarios, setListUsuarios] = useState<UsuarioTableProps[]>([])
  const [sequence, setSequence] = useState<number | undefined>()
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [selectRow, setSelectRow] = useState<DiretoriaEstatutariaResultProps | undefined>()


  const post = (value: DiretoriaEstatutariaProps) => {
    postDiretoriaEstatutaria({ ...value, sequence } as DiretoriaEstatutariaProps)
      .then((result) => {
        if (result && result.valid) {
          setInitialValue({
            usuarioId: '',
            usuarioNome: '',
          } as DiretoriaEstatutariaProps)
        }
        getAll();
      });
  }

  
  const handleUpdate = () => {
    if (!selectRow) return;

    updateDiretoriaEstatutaria(selectRow as any)
      .then((result) => {
        getAll();
      });
  }

  const hasDeletar = (id: string) => {
    deleteDiretoriaEstatutaria(id)
      .then((result) => {
        getAll();
      });
  }

  const getAll = () => {
    getAllDiretoriaEstatutaria().then((result) => {
      if (result) {
        console.log(result)
        result.map((item, index) => {
          item.numeroLinha = index + 1;
        })
      }
      setListResult(result);
    });
  }

  const getAllColaboradorIntegracao = () => {
    getAllUsuariosMRN()
      .then((result) => {
        if (result) {


          setListUsuarios(result.map((item, index) => {
            return {
              ...item,
              numeroLinha: index + 1
            }
          }));
        }
      });
  }

  useEffect(() => {
    getAll();
    getAllColaboradorIntegracao();
  }, []);

  const colluns = () => {
    let colluns: ColumnProps<DiretoriaEstatutariaResultProps>[] = new Array();

    colluns.push(
      {
        title: 'N',
        dataIndex: 'numeroLinha',
        sorter: (a, b) => compareTypeNumber(a.numeroLinha, b.numeroLinha),
      });

    colluns.push(
      {
        title: 'Ordem de Aprovação',
        dataIndex: 'sequence',
        sorter: (a, b) => compareTypeNumber(a.sequence, b.sequence),
      });

    colluns.push(
      {
        title: 'Usuário',
        dataIndex: 'usuarioNome',
        ...mountFormFilterDropDown('usuarioNome', 'Pesquisar'),
        sorter: (a, b) => compareText(a.usuarioNome, b.usuarioNome),
      });

    colluns.push({
      title: `Ação`,
      align: 'center',
      render: (text, row, index) => {
        return (
          <>
            <Button
              onClick={() => {
                console.log(row);
                setShowModalUpdate(true);
                setSelectRow(row);
              }}
              icon="commons-edit"
              okText="Atualizar"
            />

            <Button
              onClick={() => hasDeletar(row.id)}
              icon="commons-delete"
              confirm="Deseja realmente excluir este registro?"
              okText="Excluir"
            />


          </>
        );
      },
    });

    return colluns;
  }

  const validationSchema = Yup.object().shape({
    usuarioId: Yup.string().required('Colaborador deve ser informado'),
    sequence: Yup.number().required('A ordem de aprovação deve ser informado'),
  });


  const onChangeInicialValue = (value: Usuario) => {
    let formInicial = { ...initialValue, sequence };

    formInicial.usuarioId = value.id;
    formInicial.usuarioNome = `${value.nome}`;

    setInitialValue(formInicial);
  }

  return (<>
    <SimpleView >
      <GridView
        noform>
        <MasterDetailForm
          validationSchema={validationSchema}
          initialValues={initialValue}
          onSubmit={values => {
            post(values);
          }}>
          <Widget
            actions={[
              hasPermission(['NAO_PREVISTO_APROVADOR_ALTERNATIVO_CADASTRAR']) && (
                <FormSubmitButton
                  type="default">
                  <FormatText id="ui.commons.save" uppercase />
                </FormSubmitButton>),
            ]}>
            <Row style={{ display: 'flex', alignItems: 'center' }}>

              <Col span={4}>
                <FormInput
                  label="Ordem de Aprovação"
                  name="sequence"
                  type='number'
                  value={sequence}
                  onChange={(e) => setSequence(Number(e.target.value))}
                />
              </Col>


              <Col span={10}>
                <FormInput
                  label="Colaborador"
                  name="usuarioId"
                  disabled
                  value={initialValue ? initialValue.usuarioNome : ''}
                />
              </Col>


              <Col span={1}>
                <ModalColaborador
                  usuarios={listUsuarios}
                  definirValorColoborador={(value) => {
                    if (value) {
                      onChangeInicialValue(value);
                    }
                  }}
                />
              </Col>

            </Row>

          </Widget>


          <Widget title="Resultado">

            <Modal
              visible={showModalUpdate}
              width={1024}
              title="Atualizar Ordem de Aprovação"
              onCancel={() => setShowModalUpdate(false)}
              footer={[
                <Button
                  type='default'
                  onClick={() => setShowModalUpdate(false)}>
                  Fechar
                </Button>,
                <Button
                  type="default" onClick={handleUpdate}>
                  Salvar
                </Button>,
              ]}
            >

              <FormInput
                label="Colaborador"
                name="usuarioId"
                style={{ marginTop: '8px' }}
                disabled
                value={selectRow?.usuarioNome}
              />

              <FormInput
                label="Ordem de Aprovação"
                name="sequence"
                type='number'
                value={selectRow?.sequence}
                onChange={(e) => setSelectRow(selectRow ? { ...selectRow, sequence: Number(e.target.value) } : undefined)}
              />

            </Modal>

            <Table
              id={'tabelaDiretoriaEstatutaria'}
              rowKey="id"
              columns={colluns()}
              dataSource={listResult}

            />
          </Widget>
        </MasterDetailForm>

      </GridView>
    </SimpleView>

  </>)

}

export default DiretoriaEstatutaria;